<template>
  <Index />
</template>

<script setup>
import Index from './views/Index.vue'
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
html, body, #app {
  width: 100%;
  height: 100%;
  background: #0a1a30;
  overflow: hidden;
}
</style>